
import SubscriptionPricingContent from '../../features/Subscription/SubscriptionPricingContent';
import MainLayout from '../../layouts/MainLayout/MainLayout';
import './Subscription.css'
import {  Stack } from '@mantine/core';
import { Helmet } from "react-helmet";




export default function Subscription() {
   return (
      <>
         <Helmet>
            <title>FORVET | Suscripciones</title>
            <meta name="description"
               content="Formá parte de una comunidad que apuesta al crecimiento constante, la actualización profesional y el intercambio con colegas apasionados como vos. Descubrí nuevas herramientas, perspectivas y oportunidades diseñadas para llevar tu vocación un paso más allá." />
            <meta property="og:title" content="FORVET | Suscripciones" />
            <meta property="og:description"
               content="Formá parte de una comunidad que apuesta al crecimiento constante, la actualización profesional y el intercambio con colegas apasionados como vos. Descubrí nuevas herramientas, perspectivas y oportunidades diseñadas para llevar tu vocación un paso más allá." />
         </Helmet>
         <MainLayout>
            <div className="SubscriptionPage-main-container">
               <h1 className="landingHero__title">
                  Comunidad <br />
                  <span className="landingHero__gradient">
                     Forvet
                  </span>
               </h1>
               <Stack mb={20}>
                  <p className='SubscriptionPage--description'>
                     Formá parte de una comunidad que apuesta al <strong>crecimiento constante</strong>, la <strong>actualización profesional</strong> y el intercambio con colegas apasionados <strong>como vos</strong>.
                  </p>
                  <p className='SubscriptionPage--description'>
                     Descubrí nuevas herramientas, perspectivas y oportunidades diseñadas para llevar tu vocación un paso más allá.
                  </p>
               </Stack>

               <SubscriptionPricingContent/>

            </div>
         </MainLayout>
      </>
   )
}
